@if (!isExpert) {
  <div class="animation" [ngClass]="{'blinking': recording}">
    <div [ngClass]="{'blinking-icon': recording}" class="recording-indicator">
      <!-- Icono parpadeante
      <mat-icon [ngClass]="{'recording-icon': true}" class="recording-icon">videocam</mat-icon>-->
      <span class="material-icons notranslate md-light">videocam</span>
    </div>
  </div>
}
<div class="background"></div>

@if (session) {
  <div #publisherContainer>
    <app-publisher [session]="session" [isExpert]="isExpert" [publisherType]="publisherType.Video"></app-publisher>
    <app-publisher style="display: none" [session]="session" [isExpert]="isExpert" [publisherType]="publisherType.ShareScreen" (onScreenShareStop)="stopScreenSharing()"></app-publisher> <!--#publisherShareScreen-->
    <app-publisher style="display: none" [session]="session" [isExpert]="isExpert" [publisherType]="publisherType.AudioTranslate"></app-publisher>
  </div>
}

@if (session) {
  <div>
    @for (stream of streams; track stream) {
      <app-subscriber [stream]="stream" [session]="session" [isExpert]="isExpert"></app-subscriber>
    }
  </div>
}


<div class="content" #videoContainer (click)="showPointer($event)">
  <div class="end-call-button-area">
    <div class="end-call-button" (click)="hangUp($event)"></div>
  </div>

  <div class="main">
    @if (subtitle != '') {
      <div class="traducciones">
        <p>{{ subtitle }}</p>
      </div>
    }
  </div>

  @if (currentnavBar == navBars.BASIC) {
    <div class="buttons-area" #container>
      <div class="round-button silence-button" (click)="switchMicrophone($event)" #button>
        @if (microActive) {
          <img src="/assets/images/buttons/voice-on.svg" alt="Icono">
        }
        @if (!microActive) {
          <img src="/assets/images/buttons/voice-off.svg" alt="Icono">
        }
      </div>
      @if (hasFlash) {
        <div class="round-button flash-button" (click)="switchFlash($event)" #button>
          @if (!flashOn) {
            <img src="/assets/images/buttons/flash-off.svg" alt="Icono">
          }
          @if (flashOn) {
            <img src="/assets/images/buttons/flash-on.svg" alt="Icono">
          }
        </div>
      }
      <div class="round-button members-button" (click)="switchSection('members', $event)" #button>
        <img src="/assets/images/buttons/contacts.svg" alt="Icono">
      </div>
      <div class="round-button chat-button" (click)="switchSection('chat', $event)" #button>
        <img src="/assets/images/buttons/chat.svg" alt="Icono">
      </div>
      @if (isExpert) {
        <div class="round-button capture-button" (click)="captureAndEdit($event)" #button>
          <img src="/assets/images/buttons/capture.svg" alt="Icono">
        </div>
      }
      @if (isExpert) {
        <div class="round-button capture-button" (click)="requestHDCapture($event)" #button>
          <img src="/assets/images/buttons/hd-screen-capture.svg" alt="Icono">
        </div>
      }
      @if (isExpert) {
        <div class="round-button record-button" #button>
          @if (!recording) {
            <img src="/assets/images/buttons/record.svg" alt="Icono" (click)="startRecording($event)">
          }
          @if (recording) {
            <img src="/assets/images/buttons/stop.svg" alt="Icono" (click)="stopRecording($event)">
          }
          @if (recording) {
            <div class="recording" (click)="stopRecording($event)">
              <img src="/assets/images/buttons/stop.svg" alt="Icono">
              <div class="time">{{ getRecordingTime() }}</div>
            </div>
          }
        </div>
      }
      @if (screenShareAvailable) {
        <div [ngClass]="{'disabled': screenShareDisabled }" class="round-button screen-share-button"
          (click)="switchScreenSharing($event)" #button>
          @if (!screenShareOn) {
            <img src="/assets/images/buttons/screen-share.svg" alt="Icono">
          }
          @if (screenShareOn) {
            <img src="/assets/images/buttons/stop-sharing.svg" alt="Icono">
          }
        </div>
      }
      @if (isExpert) {
        <div class="round-button tags-button" (click)="openTagsModal($event)" #button>
          @if (assetInfo && !assetInfo.tags[0]) {
            <img src="/assets/images/buttons/tags.svg" alt="tags">
          }
          @if (assetInfo && assetInfo.tags[0]) {
            <img src="/assets/images/buttons/tags-with-data.svg" alt="tags">
          }
        </div>
      }
      @if (hasResolution) {
        <div class="round-button resolution-button" (click)="changeButtonsTo(navBars.RESOLUTION, $event)" #button>
          @if (resolution == 1080) {
            <img src="/assets/images/buttons/resolution-1080.svg" alt="Icono">
          }
          @if (resolution == 720) {
            <img src="/assets/images/buttons/resolution-720.svg" alt="Icono">
          }
          @if (resolution == 480) {
            <img src="/assets/images/buttons/resolution-480.svg" alt="Icono">
          }
          @if (resolution == 240) {
            <img src="/assets/images/buttons/resolution-240.svg" alt="Icono">
          }
        </div>
      }
      @if (!isExpert) {
        <div class="round-button change-camera-button" (click)="switchCamera($event)" #button>
          <img src="/assets/images/buttons/change-camera.svg" alt="Icono">
        </div>
      }
      @if (showFullscreenButton) {
        <div class="round-button full-screen-button" (click)="switchFullScreen($event)" #button>
          @if (!fullScreen) {
            <img src="/assets/images/buttons/full-screen.svg" alt="Icono">
          }
          @if (fullScreen) {
            <img src="/assets/images/buttons/regular-screen.svg" alt="Icono">
          }
        </div>
      }
    </div>
  }
  @if (currentnavBar == navBars.RESOLUTION) {
    <div class="buttons-area">
      <div class="round-button close-button" (click)="changeButtonsTo(navBars.BASIC, $event)">
        <img src="/assets/images/buttons/close.svg" alt="Icono">
      </div>
      <div class="round-button resolution-button" (click)="setResolution(1080, $event)">
        <img src="/assets/images/buttons/resolution-1080.svg" alt="Icono">
      </div>
      <div class="round-button resolution-button" (click)="setResolution(720, $event)">
        <img src="/assets/images/buttons/resolution-720.svg" alt="Icono">
      </div>
      <div class="round-button resolution-button" (click)="setResolution(480, $event)">
        <img src="/assets/images/buttons/resolution-480.svg" alt="Icono">
      </div>
      <div class="round-button resolution-button" (click)="setResolution(240, $event)">
        <img src="/assets/images/buttons/resolution-240.svg" alt="Icono">
      </div>
    </div>
  }
</div>
@if (chatOn) {
  <directCall-chat (close)="switchSection('chat', $event)"></directCall-chat>
}
<directCall-members [class.membersOff]="!membersOn" (close)="switchSection('members', $event)"></directCall-members>
@for (participant of assetInfo?.participants; track participant) {
  <directCall-pointer [position]="participant.pointer" [role]="participant.role"></directCall-pointer>
}
